import constants from './constants';
import { ENDPOINTS } from '../../../types/endpoints';
import { KNOWN_QUERY_PARAMS } from '../../../server/services/QueryInputService/QueryInputService.types';
export default {
    getInitiallySelectedOptionValue: function (options, requiredValue) {
        if (typeof requiredValue === 'undefined') {
            return constants.defaultValue;
        }
        for (var i = 0; i < options.length; i++) {
            var value = options[i].value;
            if (value >= requiredValue) {
                return value;
            }
        }
        return constants.defaultValue;
    },
    getUrlToSwitch: function (loanAmount) {
        var _a = window.location, origin = _a.origin, search = _a.search;
        var preferredRoute = loanAmount < constants.minLoanAmountForRoute1
            ? ENDPOINTS.MORTGAGE_ROUTE_2
            : ENDPOINTS.MORTGAGE_ROUTE_1;
        var url = new URL("".concat(origin).concat(preferredRoute).concat(search));
        url.searchParams.set(KNOWN_QUERY_PARAMS.AMOUNT, String(loanAmount));
        url.searchParams.set(KNOWN_QUERY_PARAMS.PREVENT_SWITCH, '1');
        return String(url);
    },
};
